<div class="dialog-box">
    <div class="dialog-header">
        <p class="heading">Pins List</p>
        <mat-icon aria-hidden="false" fontIcon="close" class="icon" (click)="closeDialog()"></mat-icon>
    </div>

    <div class="dialog-body">

        <table mat-table [dataSource]="dataSource" aria-describedby="" ngClass="styled-table">
            <!-- serialNo Column -->
            <ng-container matColumnDef="serialNo">
                <th mat-header-cell *matHeaderCellDef ngClass="styled-head">No.</th>
                <td mat-cell *matCellDef="let element; let i = index;">{{i+1}}</td>
            </ng-container>

            <!-- invoiceNumber Column -->
            <ng-container matColumnDef="pinNumber">
                <th mat-header-cell *matHeaderCellDef ngClass="styled-head">Pin Number</th>
                <td mat-cell *matCellDef="let element">{{ element }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true" ngClass="styled-head"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>

    <div class="dialog-footer">
        <button class="dialog-footer-btn white-btn" (click)="closeDialog()">
            Close
        </button>
    </div>
</div>